const locale = {
	EXKURSIO: "Exkursio",
	OVERVIEW: "Übersicht",
	WELCOMEBACK: "Willkommen zurück",
	TRIPS: "Fahrten",
	MYTRIPS: "Meine Fahrten",
	EMPLOYEETRIPS: "Mitarbeiter Fahrten",
	VEHICLES: "Fahrzeuge",
	MYVEHICLES: "Meine Fahrzeuge",
	EMPLOYEEVEHICLES: "Mitarbeiter Fahrzeuge",
	REPORTS: "Reporte",
	QUICKNAVIGATION: "Schnellnavigation",
	LIVESTATS: "Live Statistiken",
	ACTIVETRIPS: "Aktive Fahrten",
	AVAILABLEVEHICLES: "Verfügbare Fahrzeuge",
	VEHICLE: "Fahrzeug",
	KMTHISMONTH: "km diesen Monat",
	FUELEFFICIENCY: "Kraftstoffeffizienz",
	RECENTTRIPS: "Letzte Fahrten",
	VEHICLESTATUS: "Fahrzeugstatus",
	DRIVER: "Fahrer",
	FUEL: "Kraftstoff",
	ACTIVE: "Aktiv",
	COMPLETED: "Abgeschlossen",
	SCHEDULED: "Geplant",
	AVAILABLE: "Verfügbar",
	MAINTENANCE: "Wartung",
	INACTIVE: "Inaktiv",
	ARCHIVED: "Archiviert",
	SEARCH: "Suchen",
	VEHICLESNOTAVAILABLE: "Fahrzeuge nicht verfügbar",
	NOVEHICLESFOUND: "Keine Fahrzeuge gefunden",
	GOTOVEHICLES: "Zu den Fahrzeugen",
	NODATAFOUND: "Keine Daten gefunden",
	VIEWING_VEHICLES_FOR: "Fahrzeuge anzeigen für",
	CLOSE: "Schließen",
	ADDVEHICLE: "Fahrzeug hinzufügen",
	BACK: "Zurück",
	EDIT: "Bearbeiten",
	CAPACITY: "Kapazität",
	PERSONCAPACITY: "Personenkapazität",
	PERSONS: "Personen",
	TYPE: "Typ",
	UNKNOWN: "Unbekannt",
	VEHICLENAME: "Fahrzeugname",
	DESCRIPTION: "Beschreibung",
	LICENSEPLATE: "Kennzeichen",
	VEHICLETYPE: "Fahrzeugtyp",
	CAR: "PKW",
	SUV: "SUV",
	TRUCK: "LKW",
	VAN: "Transporter",
	BUS: "Bus",
	MINIBUS: "Kleinbus",
	MOTORCYCLE: "Motorrad",
	PICKUP: "Pickup",
	TRAILER: "Anhänger",
	SEMITRAILER: "Sattelanhänger",
	CAMPER: "Wohnmobil",
	CONVERTIBLE: "Cabrio",
	COUPE: "Coupé",
	SEDAN: "Limousine",
	HATCHBACK: "Schrägheck",
	WAGON: "Kombi",
	CROSSOVER: "Crossover",
	MINIVAN: "Van",
	YEAROFMANUFACTURE: "Baujahr",
	LICENSEDTO: "Zugelassen auf",
	PS: "Pferdestärken (PS)",
	CURRENTLOCATION: "Aktueller Standort",
	BRAND: "Marke",
	MODEL: "Modell",
	YEAR: "Jahr",
	FUELTYPE: "Kraftstoffart",
	DIESEL: "Diesel",
	GASOLINE: "Benzin",
	ELECTRIC: "Elektrisch",
	HYBRID: "Hybrid",
	CNG: "CNG (Erdgas)",
	LPG: "LPG (Autogas)",
	HYDROGEN: "Wasserstoff",
	BIODIESEL: "Biodiesel",
	ETHANOL: "Ethanol",
	PLUGINHYBRID: "Plug-in Hybrid",
	EDITVEHICLE: "Fahrzeug bearbeiten",
	CREATENEWVEHICLE: "Neues Fahrzeug erstellen",
	ARCHIVEVEHICLE: "Fahrzeug archivieren",
	CREATEDAT: "Erstellt am",
	CREATEDBY: "Erstellt von",
	SAVE: "Speichern",
	LOADING: "Laden",
	VEHICLESAVED: "Fahrzeug erfolgreich gespeichert",
	CREATED: "Erstellt",
	FROM: "von",
	ME: "mir",
	CREATENEWTRIP: "Neue Fahrt erstellen",
	EDITTRIP: "Fahrt bearbeiten",
	TRIPNAME: "Fahrtname",
	STARTDATE: "Startdatum",
	ENDDATE: "Enddatum",
	STARTTIME: "Startzeit",
	ENDTIME: "Endzeit",
	DESTINATION: "Ziel",
	PARTICIPANTS: "Teilnehmer",
	STATUS: "Status",
	PENDING: "Ausstehend",
	CONFIRMED: "Bestätigt",
	CANCELLED: "Storniert",
	DATE: "Datum",
	TIME: "Zeit",
	ACTIONS: "Aktionen",
	NOTRIPSTHISPERIOD: "Keine Fahrten für diesen Zeitraum gefunden",
	TRACK: "Strecke",
	KILOMETERS: "Kilometer",
	REASON: "Zweck",
	STARTDATETIME: "Startzeitpunkt",
	ENDDATETIME: "Endzeitpunkt",
	ATTENTION: "Achtung",
	DELETETRIPQUESTION: "Möchten Sie diese Fahrt wirklich löschen?",
	YES: "Ja",
	NO: "Nein",
	DAY: "Tag",
	WEEK: "Woche",
	MONTH: "Monat",
	TOTALTRIPS: "Fahrten gesamt",
	TOTALKM: "Gesamtkilometer",
	STARTKM: "Start KM",
	ENDKM: "End KM",
	LASTTRIPENDKM: "Letzte Fahrt End KM",
	SEAL: "Versiegeln",
	RANGE: "Zeitraum",
	SEALING: "Versiegelung",
	SEALED: "Versiegelt",
	ENTERREASONFORSEALING: "Grund für die Versiegelung dieses Zeitraums eingeben...",
	SEALTRIP: "Fahrt versiegeln",
	SEALTRIPQUESTION: "Sind Sie sicher, dass Sie diese Fahrt versiegeln möchten?",
	SELECTMONTH: "Monat auswählen",
	SELECTDATE: "Datum auswählen",
	CANCEL: "Abbrechen",
	COMMENT: "Kommentar",
	OPTIONALCOMMENT: "Optionaler Kommentar...",
	REPORTTYPE: "Reportart",
	OBSERVATIONPERIOD: "Betrachtungszeitraum",
	SELECTREPORTTYPE: "Report-Typ auswählen",
	COMINGSOON: "Bald verfügbar",
	SELECTPERIOD: "Zeitraum auswählen",
	SELECTVEHICLES: "Fahrzeuge auswählen",
	THISMONTH: "Diesen Monat",
	LASTMONTH: "Letzten Monat",
	THISYEAR: "Dieses Jahr",
	LASTYEAR: "Letztes Jahr",
	BACK: "Zurück",
	NEXT: "Weiter",
	EMPLOYEESWITHEXKURSIO: "Mitarbeiter mit Exkursio",
	PEOPLE: "Personen",
	NAME: "Name",
	USERNAME: "Benutzername",
	DISPLAYNAME: "Anzeigename",
	TOTHETRIPS: "Zu den Fahrten",
	LINKNOTVALIDFORUSER: "Link nicht gültig für diesen Benutzer",
	GENERATEREPORT: "Report generieren",
	REPORTFOR: "Report für",
	CALCULATIONDATE: "Berechnungsdatum",
	LOADINGREPORT: "Report wird geladen...",
	AVERAGEDISTANCE: "Durchschnittliche Entfernung",
	AVERAGEDURATION: "Durchschnittliche Dauer",
	TRIPSBYREASON: "Zeit nach Fahrzeugen",
	VEHICLEPERFORMANCE: "Fahrzeugleistung",
	DAILYDISTANCE: "Tägliche Entfernung",
	DAILYSTATS: "Tagesstatistiken",
	DETAILEDBREAKDOWN: "Detaillierte Aufschlüsselung",
	TOTALDURATION: "Gesamtdauer",
	AVERAGEKM: "Durchschnittliche KM",
	THISWEEK: "Diese Woche",
	LASTWEEK: "Letzte Woche",
	SELECTALL: "Alle auswählen",
	DESELECTALL: "Alle abwählen",
	CHOOSEVEHICLES: "Fahrzeuge auswählen",
	SHOWARCHIVEDVEHICLES: "Archivierte Fahrzeuge anzeigen",
	SELECTNOTHING: "Nichts auswählen",
	EXPORT: "Exportieren",
	TRIPCOUNT: "Anzahl Fahrten",
	KILOMETERS: "Kilometer",
	DISTANCE: "Entfernung",
	DURATION: "Dauer",
	DATE: "Datum",
	VEHICLES: "Fahrzeuge",
	COLOR: "Farbe",
	ICON: "Symbol",
	TODAY: "Heute",
	TOTALDISTANCE: "Gesamtdistanz",
	USEDVEHICLES: "Verwendete Fahrzeuge",
	TOTALTIME: "Gesamtzeit",
	DAYSSTATUS: "Tagesstatus",
	UNSEALED: "Nicht versiegelt",
	UNSEALDATERANGEQUESTION: "Möchten Sie diesen Datumsbereich entsiegeln?",
	UNSEALTRIPQUESTION: "Möchten Sie diese Fahrt entsiegeln?",
	EXPORTSELECTEDDATA: "Ausgewählte Daten exportieren",
	EXPORTAS: "Exportieren als",
	EXPORTTYPE: "Export-Typ",
	SHORTSUMMARY: "Kurzzusammenfassung",
	DAYTOTALOVERVIEW: "Fahrzeug-Gesamtübersicht",
	SINGLELISTINGS: "Einzelauflistungen",

	DATEANDTIMEFORMAT: "Datum & Zeit Format",
	DATEANDTIMECOMBINED: "Datum & Zeit kombiniert",
	DATEONLY: "Nur Datum",
	TIMEONLY: "Nur Zeit",
	DURATIONSUMFORMAT: "Dauer & Summen Format",
	HOURSMINUTESSECONDS: "Stunden, Minuten, Sekunden",
	HOURSMINUTES: "Stunden, Minuten",
	HOURS: "Stunden",
	MINUTES: "Minuten",
	SECONDS: "Sekunden",
	WITHSIGNATURE: "mit Unterschriftsfeld",
	SHOWCALCULATIONTIMESTAMP: "Berechnungszeitpunkt anzeigen",
	SHOWSEALEDREPORT: "Versiegelung im Report anzeigen",
	SEALDATERANGE: "Zeitraum beim Report-Export versiegeln",
	SEALDATERANGECONFIRM: "Möchten Sie den Zeitraum beim Exportieren dieses Reports wirklich versiegeln?",
	DATERANGEALREADYSEALED: "Dieser Zeitraum ist bereits versiegelt. Der Export wird ohne zusätzliche Versiegelung fortgesetzt.",
	SEALEDRANGES: "Bestehende versiegelte Zeiträume",
	ALREADYSEALED: "bereits versiegelt",
	PARTIALLYSEALED: "teilweise versiegelt",
	EXPORTREPORT: "Report exportieren",
	STARTDATE: "Startdatum",
	ENDDATE: "Enddatum",
	TRACK: "Strecke",
	STARTKM: "Start KM",
	ENDKM: "End KM",
	LICENSEPLATE: "Kennzeichen",
	TOTALTRIPS: "Gesamtfahrten",
	STARTTIME: "Startzeit",
	ENDTIME: "Endzeit",
	ROUTE: "Strecke",
	BRAND: "Marke",
	MODEL: "Modell",
	VEHICLESTATISTICS: "Fahrzeugstatistiken",
	DETAILEDTRIPS: "Detaillierte Fahrtenauflistung",
	UNIQUEVEHICLES: "Fahrzeuge",
	ACCEPTANCE: "Bestätigung",
	SIGNATURESUPERVISOR: "Vorgesetzter",
	SIGNATUREEMPLOYEE: "Mitarbeiter",
	SIGNATUREINFOTEXT: "Hiermit bestätige ich die Richtigkeit der oben aufgeführten Angaben.",
	ONLINE: "Online",
	AWAY: "Abwesend",
	RECENTLY_ACTIVE: "Kürzlich aktiv",
	OFFLINE: "Offline",
	UNKNOWN: "Unbekannt",
	NEVER: "Nie",
	JUST_NOW: "Gerade eben",
	MINUTES_AGO: "vor {{count}} Minuten",
	MINUTES_AGO_plural: "vor {{count}} Minuten",
	HOURS_AGO: "vor {{count}} Stunden",
	HOURS_AGO_plural: "vor {{count}} Stunden",
	DAYS_AGO: "vor {{count}} Tagen",
	DAYS_AGO_plural: "vor {{count}} Tagen",
	THIS_MONTH: "Diesen Monat",
	LAST_ONLINE: "Zuletzt online",
	FOR: "für"
};

export default locale;
